import DocsService from "~/services/docsService";
import MailService from "~/services/mailService";

export interface IApiInstance {
    docs: DocsService
    mail: MailService
}

export default defineNuxtPlugin((nuxtApp) => {

    const $config = useRuntimeConfig();
    const params : IServiceParams = {$config}

    const modules: IApiInstance = {
        docs: new DocsService(params),
        mail: new MailService(params)
    };

    return {
        provide: {
            api: modules
        }
    };
});
